/* eslint-disable */
/** 由 scripts/generate-xinli-sand-manifest.js 自动生成，勿手改 */
export const XINLI_SAND_DIR = '/static/models/心理沙盘模型/'

export const XINLI_SAND_MANIFEST = [
  // {
  //   "tab": "artificial",
  //   "label": "办公楼",
  //   "emoji": "🏠",
  //   "modelKey": "xinli:办公楼",
  //   "modelParts": [
  //     "/static/models/心理沙盘模型/人造物/3个大厦/办公楼/SM_Bld_OfficeOctagon_Base_01.fbx",
  //     "/static/models/心理沙盘模型/人造物/3个大厦/办公楼/SM_Bld_OfficeOctagon_Floor_01.fbx",
  //     "/static/models/心理沙盘模型/人造物/3个大厦/办公楼/SM_Bld_OfficeOctagon_Roof_01.fbx"
  //   ],
  //   "modelUrl": "/static/models/心理沙盘模型/人造物/3个大厦/办公楼/SM_Bld_OfficeOctagon_Base_01.fbx",
  //   "thumbUrl": "/static/models/心理沙盘模型/人造物/3个大厦/办公楼/办公楼.png",
  //   "textureUrl": "/static/models/心理沙盘模型/人造物/3个大厦/PolygonCity_Texture_03_A.png",
  //   "targetHeight": 2.2
  // },
  {
    "tab": "artificial",
    "label": "冰激凌",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:冰激凌1",
    "modelUrl": "/static/models/心理沙盘模型/各种食物合集/冰激凌/bingqiling.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/各种食物合集/冰激凌/冰淇淋1.png",
    "textureUrl": "/static/models/心理沙盘模型/各种食物合集/map_shiwu.png",
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "冰激凌2",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:冰激凌2",
    "modelUrl": "/static/models/心理沙盘模型/各种食物合集/冰激凌/bingqiling02.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/各种食物合集/冰激凌/冰淇淋2.png",
    "textureUrl": "/static/models/心理沙盘模型/各种食物合集/map_shiwu.png",
    "textureTintColor": "#ff88aa",
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "冰屋",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:冰屋",
    "modelUrl": "/static/models/心理沙盘模型/人造物/冰屋/bingwu.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/冰屋/冰屋.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/冰屋/bingwu.PNG",
    "modelRotation": [0, 0, 0],
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "冰箱",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:冰箱",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/冰箱/bingxiang.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/冰箱/冰箱.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/jiaju.png",
    "targetHeight": 0.65
  },
  {
    "tab": "artificial",
    "label": "布丁",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:布丁",
    "modelUrl": "/static/models/心理沙盘模型/各种食物合集/布丁/buding.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/各种食物合集/布丁/布丁.png",
    "textureUrl": "/static/models/心理沙盘模型/各种食物合集/map_shiwu.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "茶几",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:茶几",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/茶几/chaji.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/茶几/茶几.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/茶几/茶几.png",
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "超市",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:超市",
    "modelUrl": "/static/models/心理沙盘模型/人造物/超市/chaoshi.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/超市/百货商场.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/超市/map_chaoshi.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "炒饭",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:炒饭",
    "modelUrl": "/static/models/心理沙盘模型/炒饭/shiwu.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/炒饭/shiwu.png",
    "textureUrl": "/static/models/心理沙盘模型/炒饭/map_shiwu.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "城堡",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:城堡",
    "modelUrl": "/static/models/心理沙盘模型/人造物/城堡/Demo_Round Fort.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/城堡/城堡.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/城堡/Fortress.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 1.95
  },
  {
    "tab": "plant",
    "label": "大蒜",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:大蒜",
    "modelUrl": "/static/models/心理沙盘模型/各种农村物件/大蒜/cj3_01_suan.obj",
    "thumbUrl": "/static/models/心理沙盘模型/各种农村物件/大蒜/蒜头.png",
    "meshTextures": {
      "cj3_01_suan": "/static/models/心理沙盘模型/各种农村物件/cj3_01.PNG"
    },
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "灯塔",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:灯塔",
    "modelUrl": "/static/models/心理沙盘模型/人造物/灯塔+古代高塔/灯塔/dengta.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/灯塔+古代高塔/灯塔/灯塔.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/灯塔+古代高塔/灯塔/灯塔.png",
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "电视",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:电视",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/电视/dianshi.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/电视/电视.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/电视/电视.png",
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "古代高塔",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:古代高塔",
    "modelUrl": "/static/models/心理沙盘模型/人造物/灯塔+古代高塔/古代高塔/haunghelou.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/灯塔+古代高塔/古代高塔/古代楼阁.PNG",
    "textureUrl": "/static/models/心理沙盘模型/人造物/灯塔+古代高塔/SimplePort.png",
    "targetHeight": 1.95
  },
  {
    "tab": "artificial",
    "label": "柜子",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:柜子",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/柜子/yigui.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/柜子/柜子.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/jiaju.png",
    "targetHeight": 0.65
  },
  {
    "tab": "artificial",
    "label": "海边别墅",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:海边别墅",
    "modelUrl": "/static/models/心理沙盘模型/人造物/海边别墅/Building_House_03_color01.obj",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/海边别墅/房屋07.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/海边别墅/Building_House_03_color01.png",
    "targetHeight": 0.975
  },
  {
    "tab": "artificial",
    "label": "海边楼房",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:海边楼房",
    "modelUrl": "/static/models/心理沙盘模型/人造物/海边楼房/Building_Residential_color01.obj",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/海边楼房/住宅楼1.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/海边楼房/Building_Residential_color01.png",
    "targetHeight": 1.4625
  },
  {
    "tab": "artificial",
    "label": "火把",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:火把",
    "modelUrl": "/static/models/心理沙盘模型/火把/huoba.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/火把/huoba.png",
    "textureUrl": "/static/models/心理沙盘模型/火把/huoba _c.png",
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "加油站",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:加油站",
    "modelUrl": "/static/models/心理沙盘模型/人造物/加油站/Building_Gas_Station.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/加油站/加油站.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/加油站/Building_Gas_Station.png",
    "targetHeight": 1.3
  },
  {
    "tab": "plant",
    "label": "茄子",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:茄子",
    "modelUrl": "/static/models/心理沙盘模型/各种食物合集/茄子/qiezi.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/各种食物合集/茄子/茄子.png",
    "textureUrl": "/static/models/心理沙盘模型/各种食物合集/map_shiwu.png",
    "modelRotation": [1.5707963267948966, 0, 0],
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "金字塔",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:金字塔",
    "modelUrl": "/static/models/心理沙盘模型/人造物/金字塔-纯色-无贴图/SM_pyramids_old.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/金字塔-纯色-无贴图/金字塔.png",
    "meshColors": {
      "Box001": "#c9a045"
    },
    "modelRotation": [-1.5707963267948966, 0, 0],
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "警察局",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:警察局",
    "modelUrl": "/static/models/心理沙盘模型/人造物/警察局/jingchaju.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/警察局/警察局.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/警察局/map_jingchaju.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 1.3
  },
  // {
  //   "tab": "artificial",
  //   "label": "科技大厦",
  //   "emoji": "🏠",
  //   "modelKey": "xinli:科技大厦",
  //   "modelParts": [
  //     "/static/models/心理沙盘模型/人造物/3个大厦/科技大厦/SM_Bld_OfficeRound_Base_01.fbx",
  //     "/static/models/心理沙盘模型/人造物/3个大厦/科技大厦/SM_Bld_OfficeRound_02.fbx",
  //     "/static/models/心理沙盘模型/人造物/3个大厦/科技大厦/SM_Bld_OfficeRound_Roof_01.fbx"
  //   ],
  //   "modelUrl": "/static/models/心理沙盘模型/人造物/3个大厦/科技大厦/SM_Bld_OfficeRound_Base_01.fbx",
  //   "thumbUrl": "/static/models/心理沙盘模型/人造物/3个大厦/科技大厦/科技大厦.png",
  //   "textureUrl": "/static/models/心理沙盘模型/人造物/3个大厦/PolygonCity_Texture_03_A.png",
  //   "targetHeight": 2.4
  // },
  {
    "tab": "artificial",
    "label": "蓝色房子",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:蓝色房子",
    "modelUrl": "/static/models/心理沙盘模型/人造物/蓝色房子/Building_House_01.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/蓝色房子/蓝色房子.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/蓝色房子/Building_House_01.png",
    "targetHeight": 1.21875
  },
  {
    "tab": "plant",
    "label": "梨",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:梨",
    "modelUrl": "/static/models/心理沙盘模型/各种食物合集/梨/li.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/各种食物合集/梨/梨.png",
    "textureUrl": "/static/models/心理沙盘模型/各种食物合集/map_shiwu.png",
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "楼房1",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:楼房1",
    "modelUrl": "/static/models/心理沙盘模型/人造物/楼房1/Building_Sky_big.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/楼房1/高楼01.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/楼房1/Building_Sky_big.png",
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "楼房2",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:楼房2",
    "modelUrl": "/static/models/心理沙盘模型/人造物/楼房2/Building_Sky_small.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/楼房2/矮楼01.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/楼房2/Building_Sky_small.png",
    "targetHeight": 0.975
  },
  {
    "tab": "artificial",
    "label": "落地灯",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:落地灯",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/落地灯/luodideng.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/落地灯/落地灯.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/jiaju.png",
    "targetHeight": 0.65
  },
  {
    "tab": "artificial",
    "label": "民房",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:民房",
    "modelUrl": "/static/models/心理沙盘模型/人造物/民房/minfang_02.obj",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/民房/minfang_02.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/民房/minfang_02.JPG",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.975
  },
  {
    "tab": "artificial",
    "label": "摩天大厦",
    "emoji": "🏠",
    "modelKey": "xinli:摩天大厦",
    "modelParts": [
      "/static/models/心理沙盘模型/人造物/3个大厦/摩天大厦/SM_Bld_OfficeSquare_Base_01.fbx",
      "/static/models/心理沙盘模型/人造物/3个大厦/摩天大厦/SM_Bld_OfficeSquare_01.fbx",
      "/static/models/心理沙盘模型/人造物/3个大厦/摩天大厦/SM_Bld_OfficeSquare_Roof_01.fbx"
    ],
    "modelPartOffsets": [
      [0, 0, 0],
      [0, 0, 0],
      [0, 30, 0]
    ],
    "modelUrl": "/static/models/心理沙盘模型/人造物/3个大厦/摩天大厦/SM_Bld_OfficeSquare_Base_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/3个大厦/摩天大厦/摩天大厦.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/3个大厦/PolygonCity_Texture_03_A.png",
    "targetHeight": 3.2
  },
  {
    "tab": "artificial",
    "label": "木桥",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:木桥",
    "modelUrl": "/static/models/心理沙盘模型/人造物/木桥/PT_Wooden_Bridge_02.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/木桥/木桥.PNG",
    "textureUrl": "/static/models/心理沙盘模型/人造物/木桥/PT_texture.png",
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "平房",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:平房",
    "modelUrl": "/static/models/心理沙盘模型/人造物/平房/fangzi_02.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/平房/房子03.PNG",
    "textureUrl": "/static/models/心理沙盘模型/人造物/平房/tex_古风场景贴图_灰.PNG",
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "巧克力蛋糕",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:巧克力蛋糕",
    "modelUrl": "/static/models/心理沙盘模型/各种食物合集/巧克力蛋糕/qiaokelidangao.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/各种食物合集/巧克力蛋糕/巧克力蛋糕01.png",
    "textureUrl": "/static/models/心理沙盘模型/各种食物合集/map_shiwu.png",
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "热狗",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:热狗",
    "modelUrl": "/static/models/心理沙盘模型/人造物/热狗/sanmingzhi.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/热狗/热狗.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/热狗/PolygonTown_Texture_04_A.png",
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "沙发",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:沙发",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/沙发/shafa.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/沙发/沙发.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/沙发/沙发.png",
    "targetHeight": 0.65
  },
  {
    "tab": "artificial",
    "label": "狮身人面像",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:狮身人面像",
    "modelUrl": "/static/models/心理沙盘模型/人造物/狮身人面像-纯色-无贴图/SM_sphinx.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/狮身人面像-纯色-无贴图/狮身人面像.png",
    "meshColors": {
      "Group20518": "#c4a574"
    },
    "modelRotation": [-1.5707963267948966, 0, 0],
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "石磨",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:石磨",
    "modelUrl": "/static/models/心理沙盘模型/各种农村物件/石磨/cj3_01_shimo.obj",
    "thumbUrl": "/static/models/心理沙盘模型/各种农村物件/石磨/石磨.png",
    "meshTextures": {
      "cj3_01_shimo": "/static/models/心理沙盘模型/各种农村物件/cj3_01.PNG"
    },
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "书桌",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:书桌",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/书桌/shuzhuo.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/书桌/书桌.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/jiaju.png",
    "targetHeight": 0.65
  },
  {
    "tab": "artificial",
    "label": "双人床",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:双人床",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/双人床/shuangrenchuang.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/双人床/双人床.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/jiaju.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.65
  },
  {
    "tab": "artificial",
    "label": "水桶",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:水桶",
    "modelUrl": "/static/models/心理沙盘模型/各种农村物件/水桶/cj3_01_shuitong01.obj",
    "thumbUrl": "/static/models/心理沙盘模型/各种农村物件/水桶/水桶_1.png",
    "meshTextures": {
      "cj3_01_shuitong01": "/static/models/心理沙盘模型/各种农村物件/cj3_01.PNG"
    },
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "四合院",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:四合院",
    "modelUrl": "/static/models/心理沙盘模型/人造物/四合院/siheyuan_01.obj",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/四合院/siheyuan_01.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/四合院/siheyuan_01.JPG",
    "modelRotation": [0, 0, 0],
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "体育场",
    "emoji": "🏟️",
    "modelKey": "xinli:artificial:体育场",
    "modelUrl": "/static/models/心理沙盘模型/人造物/体育场/tiyuchang.obj",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/体育场/tiyuchang.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/体育场/tiyuchang_map.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 3.25
  },
  {
    "tab": "artificial",
    "label": "木屋",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:木屋",
    "modelUrl": "/static/models/心理沙盘模型/人造物/木屋/muwu.obj",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/木屋/muwu.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/木屋/muwu_map.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "甜甜圈1",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:甜甜圈1",
    "modelUrl": "/static/models/心理沙盘模型/各种食物合集/甜甜圈1/tiantianquan.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/各种食物合集/甜甜圈1/甜甜圈01.png",
    "textureUrl": "/static/models/心理沙盘模型/各种食物合集/map_shiwu.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "甜甜圈2",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:甜甜圈2",
    "modelUrl": "/static/models/心理沙盘模型/各种食物合集/甜甜圈2/tiantianquan02.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/各种食物合集/甜甜圈2/甜甜圈02.png",
    "textureUrl": "/static/models/心理沙盘模型/各种食物合集/map_shiwu.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "甜甜圈3",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:甜甜圈3",
    "modelUrl": "/static/models/心理沙盘模型/各种食物合集/甜甜圈3/tiantianquan03.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/各种食物合集/甜甜圈3/甜甜圈03.png",
    "textureUrl": "/static/models/心理沙盘模型/各种食物合集/map_shiwu.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "亭子",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:亭子",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/亭子/tingzi.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/亭子/亭子.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/jiaju.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.65
  },
  {
    "tab": "artificial",
    "label": "图腾柱",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:图腾柱",
    "modelUrl": "/static/models/心理沙盘模型/人造物/图腾柱/SM_obelisk_egypt.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/图腾柱/图腾柱.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/图腾柱/SM_obelisk_egypt_M_obelisk_AlbedoTransparency.png",
    "modelRotation": [-1.5707963267948966, 0, 0],
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "望远镜",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:望远镜",
    "modelUrl": "/static/models/心理沙盘模型/人造物/望远镜-无贴图/Telescope.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/望远镜-无贴图/望远镜.png",
    "meshColors": {
      "Telescope": "#3a3a3a"
    },
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "消防局",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:消防局",
    "modelUrl": "/static/models/心理沙盘模型/人造物/消防局/xiaofangju.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/消防局/消防局.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/消防局/map_xiaofangju.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "学校",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:学校",
    "modelUrl": "/static/models/心理沙盘模型/人造物/学校/xuexiao.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/学校/学校.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/学校/map_jiaoxuelou.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "医院",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:医院",
    "modelUrl": "/static/models/心理沙盘模型/人造物/医院/yiyuan.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/医院/医院.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/医院/map_yiyuan.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.975
  },
  {
    "tab": "artificial",
    "label": "椅子",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:椅子",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/椅子/yizi.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/椅子/椅子.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/椅子/椅子.png",
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "邮局",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:邮局",
    "modelUrl": "/static/models/心理沙盘模型/人造物/邮局/youju.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/邮局/邮局.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/邮局/map_youju.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.65
  },
  {
    "tab": "plant",
    "label": "玉米",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:玉米",
    "modelUrl": "/static/models/心理沙盘模型/各种农村物件/玉米/cj3_01_yumi.obj",
    "thumbUrl": "/static/models/心理沙盘模型/各种农村物件/玉米/玉米.png",
    "meshTextures": {
      "cj3_01_yumi": "/static/models/心理沙盘模型/各种农村物件/cj3_01.PNG"
    },
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "栅栏",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:栅栏",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/栅栏/zhalan01.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/栅栏/zhalan01.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/jiaju.png",
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "栅栏2",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:栅栏2",
    "modelUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/栅栏2/zhalan001.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/栅栏2/zhalan001.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/家具-共用贴图/jiaju.png",
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "帐篷",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:帐篷",
    "modelUrl": "/static/models/心理沙盘模型/人造物/帐篷/zhangpeng.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/帐篷/帐篷.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/帐篷/map_zhangpeng.png",
    "modelRotation": [0, 1.5707963267948966, 0],
    "targetHeight": 0.325
  },
  {
    "tab": "artificial",
    "label": "柱子",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:柱子",
    "modelUrl": "/static/models/心理沙盘模型/人造物/柱子/cj2_shizhuquan.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/柱子/柱子.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/柱子/cj2.png",
    "targetHeight": 1.3
  },
  {
    "tab": "artificial",
    "label": "KTV",
    "emoji": "🏠",
    "modelKey": "xinli:artificial:KTV",
    "modelUrl": "/static/models/心理沙盘模型/人造物/KTV/Building_Music_Store.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/KTV/KTV.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/KTV/Building_Music_Store.png",
    "targetHeight": 0.65
  },
  {
    "tab": "artificial",
    "label": "宝箱",
    "emoji": "🎁",
    "modelKey": "xinli:artificial:宝箱",
    "modelUrl": "/static/models/心理沙盘模型/人造物/宝箱/baoxiang.obj",
    "thumbUrl": "/static/models/心理沙盘模型/人造物/宝箱/宝箱-关闭.png",
    "textureUrl": "/static/models/心理沙盘模型/人造物/宝箱/map_baoxiang.png",
    "targetHeight": 0.325
  },
  /* 男孩 7 动作共用一套身体（放在最前面） */
  {
    "tab": "character",
    "label": "男孩-待机",
    "emoji": "🧑",
    "modelKey": "xinli:男孩-待机",
    "modelUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_daiji.FBX",
    "meshSourceUrl": "/static/models/boy.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/男孩.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_tex_512.png",
    "humanCharacter": true,
    "scaleMesh": "boy",
    "staticPose": true,
    "groundLift": 0
  },
  {
    "tab": "character",
    "label": "男孩-点头",
    "emoji": "🧑",
    "modelKey": "xinli:男孩-点头",
    "modelUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_diantou.FBX",
    "meshSourceUrl": "/static/models/boy.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/男孩-点头.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_tex_512.png",
    "humanCharacter": true,
    "scaleMesh": "boy",
    "staticPose": true,
    "groundLift": 0
  },
  {
    "tab": "character",
    "label": "男孩-开心",
    "emoji": "🧑",
    "modelKey": "xinli:男孩-开心",
    "modelUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_kaixin.FBX",
    "meshSourceUrl": "/static/models/boy.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/男孩-开心.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_tex_512.png",
    "humanCharacter": true,
    "scaleMesh": "boy",
    "staticPose": true,
    "groundLift": 0
  },
  {
    "tab": "character",
    "label": "男孩-哭",
    "emoji": "🧑",
    "modelKey": "xinli:男孩-哭",
    "modelUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_ku.FBX",
    "meshSourceUrl": "/static/models/boy.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/男孩-哭泣.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_tex_512.png",
    "humanCharacter": true,
    "scaleMesh": "boy",
    "staticPose": true,
    "groundLift": 0,
    "defaultPropPitch": -0.50
  },
  {
    "tab": "character",
    "label": "男孩-睡觉",
    "emoji": "🧑",
    "modelKey": "xinli:男孩-睡觉",
    "modelUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_shuijiao.FBX",
    "meshSourceUrl": "/static/models/boy.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/男孩-睡觉.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_tex_512.png",
    "humanCharacter": true,
    "scaleMesh": "boy",
    "staticPose": true,
    "groundLift": 0
  },
  {
    "tab": "character",
    "label": "男孩-摇头",
    "emoji": "🧑",
    "modelKey": "xinli:男孩-摇头",
    "modelUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_yaotou.FBX",
    "meshSourceUrl": "/static/models/boy.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/男孩-摇头.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_tex_512.png",
    "humanCharacter": true,
    "scaleMesh": "boy",
    "staticPose": true,
    "groundLift": 0
  },
  {
    "tab": "character",
    "label": "男孩-招手",
    "emoji": "🧑",
    "modelKey": "xinli:男孩-招手",
    "modelUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_zhaoshou.FBX",
    "meshSourceUrl": "/static/models/boy.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/男孩-招手.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/男孩-7个模型动画-1个贴图/boy_tex_512.png",
    "humanCharacter": true,
    "scaleMesh": "boy",
    "staticPose": true,
    "groundLift": 0
  },
  /* 女生 7 动作共用一套身体 */
  {
    "tab": "character",
    "label": "女孩-待机",
    "emoji": "🧑",
    "modelKey": "xinli:女生-待机",
    "modelUrl": "/static/models/心理沙盘模型/人物/女孩/Connie_daiji.FBX",
    "meshSourceUrl": "/static/models/girl.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/女孩/女孩.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/女孩/Connie.png",
    "humanCharacter": true,
    "staticPose": true,
    "heightOffset": -0.04,
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "女孩-点头",
    "emoji": "🧑",
    "modelKey": "xinli:女生-点头",
    "modelUrl": "/static/models/心理沙盘模型/人物/女孩/Connie_diantou.FBX",
    "meshSourceUrl": "/static/models/girl.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/女孩/女孩-点头.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/女孩/Connie.png",
    "humanCharacter": true,
    "staticPose": true,
    "heightOffset": -0.04,
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "女孩-挥手",
    "emoji": "🧑",
    "modelKey": "xinli:女生-挥手",
    "modelUrl": "/static/models/心理沙盘模型/人物/女孩/Connie_huishou.FBX",
    "meshSourceUrl": "/static/models/girl.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/女孩/女孩-招手.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/女孩/Connie.png",
    "humanCharacter": true,
    "staticPose": true,
    "heightOffset": -0.04,
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "女孩-开心",
    "emoji": "🧑",
    "modelKey": "xinli:女生-开心",
    "modelUrl": "/static/models/心理沙盘模型/人物/女孩/Connie_kaixin.FBX",
    "meshSourceUrl": "/static/models/girl.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/女孩/女孩.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/女孩/Connie.png",
    "humanCharacter": true,
    "staticPose": true,
    "heightOffset": -0.04,
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "女孩-哭泣",
    "emoji": "🧑",
    "modelKey": "xinli:女生-哭泣",
    "modelUrl": "/static/models/心理沙盘模型/人物/女孩/Connie_kuqi.FBX",
    "meshSourceUrl": "/static/models/girl.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/女孩/女孩-哭泣.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/女孩/Connie.png",
    "humanCharacter": true,
    "staticPose": true,
    "heightOffset": -0.04,
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "女孩-睡觉",
    "emoji": "🧑",
    "modelKey": "xinli:女生-睡觉",
    "modelUrl": "/static/models/心理沙盘模型/人物/女孩/Connie_shuijiao.FBX",
    "meshSourceUrl": "/static/models/girl.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/女孩/女孩-睡觉.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/女孩/Connie.png",
    "humanCharacter": true,
    "staticPose": true,
    "heightOffset": -0.04,
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "女孩-摇头",
    "emoji": "🧑",
    "modelKey": "xinli:女生-摇头",
    "modelUrl": "/static/models/心理沙盘模型/人物/女孩/Connie_yaotou.FBX",
    "meshSourceUrl": "/static/models/girl.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/女孩/女孩-摇头.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/女孩/Connie.png",
    "humanCharacter": true,
    "staticPose": true,
    "heightOffset": -0.04,
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "爸爸和孩子",
    "emoji": "🧑",
    "modelKey": "xinli:爸爸和孩子",
    "modelUrl": "/static/models/心理沙盘模型/人物/爸爸和孩子/man_walkwithchild.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/爸爸和孩子/爸爸和孩子.png",
    "materialTextures": [
      "/static/models/心理沙盘模型/人物/爸爸和孩子/292_wushi_02.png",
      "/static/models/心理沙盘模型/人物/爸爸和孩子/农民改2.png"
    ],
    "meshTextures": {
      "n_ca069": "/static/models/心理沙盘模型/人物/爸爸和孩子/农民改2.png",
      "wushi_02": "/static/models/心理沙盘模型/人物/爸爸和孩子/292_wushi_02.png"
    },
    "meshRemove": [
      "Object003"
    ],
    "scaleMesh": "n_ca069",
    "humanCharacter": true,
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "厨师",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:厨师",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/man-chef.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/厨师/厨师.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "工程师",
    "emoji": "🧑",
    "modelKey": "xinli:工程师-待机",
    "modelUrl": "/static/models/心理沙盘模型/人物/工程师/nan_daiji.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/工程师/男人2.png",
    "meshTextures": {
      "m01": "/static/models/心理沙盘模型/人物/工程师/map/nan.png",
      "d02": "/static/models/心理沙盘模型/人物/工程师/map/nan.png",
      "hands": "/static/models/心理沙盘模型/人物/工程师/map/nan.png"
    },
    "meshColors": {
      "m01": "#e8b890",
      "d02": "#1a1a1a",
      "hands": "#e8b890",
      "Hair_Messy": "#b8956a"
    },
    "humanCharacter": true,
    "staticPose": true,
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "工人",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:工人",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/man-construction-worker.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/工人/工人.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png",
    "targetHeight": 0.55
  },
  // {
  //   "tab": "character",
  //   "label": "工人2",
  //   "emoji": "🧑",
  //   "modelKey": "xinli:MainRig:工人2",
  //   "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/_MainRig.fbx",
  //   "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/工人2/工人2.png",
  //   "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/工人2/工人2.png",
  //   "meshKeep": [
  //     "woman-construction-worker"
  //   ],
  //   "targetHeight": 0.55
  // },
  // {
  //   "tab": "character",
  //   "label": "后羿",
  //   "emoji": "🧑",
  //   "modelKey": "xinli:character:后羿",
  //   "modelUrl": "/static/models/心理沙盘模型/人物/后羿/role_5518.fbx",
  //   "thumbUrl": "/static/models/心理沙盘模型/人物/后羿/后羿.PNG",
  //   "textureUrl": "/static/models/心理沙盘模型/人物/后羿/huang_jing_bing_gong_d2.PNG",
  //   "targetHeight": 0.55
  // },
  {
    "tab": "character",
    "label": "护士",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:护士",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/woman-doctor.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/护士/护士.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "骷髅",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:骷髅",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/man-skeleton.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/骷髅/骷髅.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "夸父",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:夸父",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/man-prehistoric.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/夸父/夸父.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "快递员",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:快递员",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/man-cyclist.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/快递员/自行车运动员-男.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "老奶奶",
    "emoji": "🧑",
    "modelKey": "xinli:Character_Grandma",
    "modelUrl": "/static/models/心理沙盘模型/人物/老奶奶和老爷爷/Character.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/人物/老奶奶和老爷爷/老奶奶/老奶奶.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/老奶奶和老爷爷/Polygon_City_Characters_Texture_01_A.png",
    "meshKeep": [
      "Character_Grandma"
    ],
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "老师",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:老师",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/man-business.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/老师/老师.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "老爷爷",
    "emoji": "🧑",
    "modelKey": "xinli:Character_Grandpa",
    "modelUrl": "/static/models/心理沙盘模型/人物/老奶奶和老爷爷/Character.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/人物/老奶奶和老爷爷/老爷爷/老爷爷.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/老奶奶和老爷爷/Polygon_City_Characters_Texture_01_A.png",
    "meshKeep": [
      "Character_Grandpa"
    ],
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "妈妈和孩子",
    "emoji": "🧑",
    "modelKey": "xinli:妈妈和孩子",
    "modelUrl": "/static/models/心理沙盘模型/人物/妈妈和孩子/woman_walkwithchild.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/妈妈和孩子/妈妈和孩子.png",
    "materialTextures": [
      "/static/models/心理沙盘模型/人物/妈妈和孩子/292_wushi_02.png",
      "/static/models/心理沙盘模型/人物/妈妈和孩子/女_red.png"
    ],
    "meshTextures": {
      "nv": "/static/models/心理沙盘模型/人物/妈妈和孩子/女_red.png",
      "wushi_02": "/static/models/心理沙盘模型/人物/妈妈和孩子/292_wushi_02.png",
      "Object001": "/static/models/心理沙盘模型/人物/妈妈和孩子/292_wushi_02.png",
      "Object002": "/static/models/心理沙盘模型/人物/妈妈和孩子/292_wushi_02.png"
    },
    "meshRemove": [
      "st",
      "Object007",
      "gan",
      "Cylinder4258",
      "Sphere01",
      "Line1107",
      "Cylinder4257",
      "Rectangle018"
    ],
    "childMeshImport": {
      "url": "/static/models/心理沙盘模型/人物/爸爸和孩子/man_walkwithchild.FBX",
      "removeLocalMeshes": ["yd"],
      "meshRemove": [
        "n_ca069",
        "Bu_Model",
        "Object003",
        "gan",
        "Cylinder4258",
        "Sphere01",
        "Line1107",
        "Cylinder4257",
        "Rectangle018"
      ],
      "scaleRefMesh": "n_ca069",
      "scaleTargetMesh": "nv",
      "alignMesh": "wushi_02",
      "alignToBody": true
    },
    "scaleMesh": "nv",
    "humanCharacter": true,
    "staticPose": true,
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "农民",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:农民",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/man-farm.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/农民/农民.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "士兵",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:士兵",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/man-soldier.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/士兵/士兵.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png",
    "targetHeight": 0.55
  },
  // {
  //   "tab": "character",
  //   "label": "士兵2",
  //   "emoji": "🧑",
  //   "modelKey": "xinli:MainRig:士兵2",
  //   "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/_MainRig.fbx",
  //   "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/士兵2/士兵2.png",
  //   "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/士兵2/士兵2.png",
  //   "meshKeep": [
  //     "woman-soldier"
  //   ],
  //   "targetHeight": 0.55
  // },
  {
    "tab": "character",
    "label": "消防员",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:消防员",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/man-fire.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/消防员/消防员.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/医生/color-atlas.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "小丑",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:小丑",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/man-clown.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/小丑/小丑.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "修理工",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:修理工",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/man-hazard.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/修理工/修理工.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/gezhong/color-atlas.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "医生",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:医生",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/医生/man-doctor.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/医生/医生.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/医生/color-atlas.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "宇航员",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:宇航员",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/宇航员/man-astronaut.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/宇航员/宇航员.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/宇航员/宇航员.png",
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "足球运动员",
    "emoji": "🧑",
    "modelKey": "xinli:MainRig:足球运动员",
    "modelUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/足球运动员/man-basketball-player.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/足球运动员/足球运动员.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/各种人-共用贴图FBX/医生/color-atlas.png",
    "targetHeight": 0.55
  },
  // 神话人物（排在最后）
  {
    "tab": "character",
    "label": "沙僧",
    "emoji": "🧑",
    "modelKey": "xinli:沙僧",
    "modelUrl": "/static/models/心理沙盘模型/人物/沙僧/沙僧.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/沙僧/沙和尚.png",
    "materialTextures": [
      "/static/models/心理沙盘模型/人物/沙僧/3dpea.com_沙僧.png",
      "/static/models/心理沙盘模型/人物/沙僧/3dpea.com_沙僧2.png"
    ],
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "孙悟空",
    "emoji": "🧑",
    "modelKey": "xinli:孙悟空",
    "modelUrl": "/static/models/心理沙盘模型/人物/孙悟空/悟空.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/孙悟空/孙悟空.png",
    "materialTextures": [
      "/static/models/心理沙盘模型/人物/孙悟空/孙悟空上.png",
      "/static/models/心理沙盘模型/人物/孙悟空/r_孙悟空下.png"
    ],
    "targetHeight": 0.55
  },
  {
    "tab": "character",
    "label": "牛魔王",
    "emoji": "🧑",
    "modelKey": "xinli:牛魔王",
    "modelUrl": "/static/models/心理沙盘模型/人物/西游角色-共用fbx/牛魔王/牛魔王.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/西游角色-共用fbx/牛魔王/牛魔王.png",
    "textureUrl": "/static/models/心理沙盘模型/人物/西游角色-共用fbx/牛魔王/cardNiuMoWang.Out.png",
    "targetHeight": 0.72,
    "scaleBoost": 1.35
  },
  {
    "tab": "character",
    "label": "唐僧",
    "emoji": "🧑",
    "modelKey": "xinli:唐僧",
    "modelUrl": "/static/models/心理沙盘模型/人物/唐僧/唐僧.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/人物/唐僧/唐僧.png",
    "materialTextures": [
      "/static/models/心理沙盘模型/人物/唐僧/3dpea.com_唐僧服装.png",
      "/static/models/心理沙盘模型/人物/唐僧/3dpea.com_唐僧脸部.png",
      "/static/models/心理沙盘模型/人物/唐僧/3dpea.com_唐僧附件.png"
    ],
    "targetHeight": 0.55
  },
  {
    "tab": "plant",
    "label": "白菜",
    "emoji": "🌿",
    "modelKey": "xinli:plant:白菜",
    "modelUrl": "/static/models/心理沙盘模型/植物/白菜/juanxincai.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/白菜/卷心菜.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/白菜/map_juanxincai.jpg",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.225
  },
  {
    "tab": "plant",
    "label": "百合花",
    "emoji": "🌿",
    "modelKey": "xinli:plant:百合花",
    "modelUrl": "/static/models/心理沙盘模型/植物/各种花/百合花/百合花.obj",
    "thumbUrl": "/static/models/心理沙盘模型/植物/各种花/百合花/百合花.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/各种花/CT_Pallete.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "百年老树",
    "emoji": "🌿",
    "modelKey": "xinli:plant:百年老树",
    "modelUrl": "/static/models/心理沙盘模型/植物/百年老树/tree_01.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/百年老树/百年老树.PNG",
    "textureUrl": "/static/models/心理沙盘模型/植物/百年老树/tree_01.png",
    "alphaTextureUrl": "/static/models/心理沙盘模型/植物/百年老树/tree_01_alpha.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.9
  },
  {
    "tab": "plant",
    "label": "风铃草",
    "emoji": "🌿",
    "modelKey": "xinli:plant:风铃草",
    "modelUrl": "/static/models/心理沙盘模型/植物/各种花/风铃草/风铃草.obj",
    "thumbUrl": "/static/models/心理沙盘模型/植物/各种花/风铃草/风铃草.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/各种花/CT_Pallete.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "胡萝卜",
    "emoji": "🌿",
    "modelKey": "xinli:plant:胡萝卜",
    "modelUrl": "/static/models/心理沙盘模型/植物/胡萝卜/huluobo.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/胡萝卜/胡萝卜.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/胡萝卜/map_huluobo.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.225
  },
  {
    "tab": "plant",
    "label": "胡桃树",
    "emoji": "🌿",
    "modelKey": "xinli:plant:胡桃树",
    "modelUrl": "/static/models/心理沙盘模型/植物/胡桃树/shu01.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/胡桃树/胡桃树.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/胡桃树/oo1.png",
    "targetHeight": 0.9
  },
  {
    "tab": "plant",
    "label": "火山",
    "emoji": "🌿",
    "modelKey": "xinli:plant:火山",
    "modelUrl": "/static/models/心理沙盘模型/植物/火山/huoshan.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/火山/火山.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/火山/jiaju.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 1.35
  },
  {
    "tab": "plant",
    "label": "菊花",
    "emoji": "🌿",
    "modelKey": "xinli:plant:菊花",
    "modelUrl": "/static/models/心理沙盘模型/植物/各种花/菊花/菊花.obj",
    "thumbUrl": "/static/models/心理沙盘模型/植物/各种花/菊花/菊花.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/各种花/CT_Pallete.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "君子兰",
    "emoji": "🌿",
    "modelKey": "xinli:plant:君子兰",
    "modelUrl": "/static/models/心理沙盘模型/植物/各种花/君子兰/君子兰.obj",
    "thumbUrl": "/static/models/心理沙盘模型/植物/各种花/君子兰/君子兰.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/各种花/CT_Pallete.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "康乃馨",
    "emoji": "🌿",
    "modelKey": "xinli:plant:康乃馨",
    "modelUrl": "/static/models/心理沙盘模型/植物/康乃馨/PT_Peony_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/植物/康乃馨/康乃馨.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/康乃馨/PT_Peony_01.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "枯树",
    "emoji": "🌿",
    "modelKey": "xinli:plant:枯树",
    "modelUrl": "/static/models/心理沙盘模型/植物/枯树/cj2_tree000.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/枯树/树木01.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/枯树/cj2 .png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.9
  },
  {
    "tab": "plant",
    "label": "兰草",
    "emoji": "🌿",
    "modelKey": "xinli:plant:兰草",
    "modelUrl": "/static/models/心理沙盘模型/植物/兰草+玫瑰/兰草/cao03.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/兰草+玫瑰/兰草/剑兰.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/兰草+玫瑰/兰草/剑兰.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "兰花",
    "emoji": "🌿",
    "modelKey": "xinli:plant:兰花",
    "modelUrl": "/static/models/心理沙盘模型/植物/各种花/兰花/兰花.obj",
    "thumbUrl": "/static/models/心理沙盘模型/植物/各种花/兰花/兰花.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/各种花/CT_Pallete.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "莲花",
    "emoji": "🌿",
    "modelKey": "xinli:plant:莲花",
    "modelUrl": "/static/models/心理沙盘模型/植物/莲花/hehua.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/莲花/荷花.PNG",
    "textureUrl": "/static/models/心理沙盘模型/植物/莲花/hehua.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "柳树",
    "emoji": "🌿",
    "modelKey": "xinli:plant:柳树",
    "modelUrl": "/static/models/心理沙盘模型/植物/柳树/SM_Tree_Willow_Medium_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/植物/柳树/柳树.PNG",
    "meshTextures": {
      "SM_Tree_Willow_Medium_01": "/static/models/心理沙盘模型/植物/榕树/PT_Tree_Trunk_01.png",
      "SM_Tree_Willow_Medium_01_Leaves": "/static/models/心理沙盘模型/植物/榕树/PT_Generic_Leaves_01.png"
    },
    "meshTextureCutout": [
      "SM_Tree_Willow_Medium_01_Leaves"
    ],
    "targetHeight": 0.9
  },
  {
    "tab": "plant",
    "label": "满天星",
    "emoji": "🌿",
    "modelKey": "xinli:plant:满天星",
    "modelUrl": "/static/models/心理沙盘模型/植物/满天星/PT_Flax_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/植物/满天星/满天星（花）.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/满天星/PT_Flax_01.png",
    "cutoutTexture": true,
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "玫瑰",
    "emoji": "🌿",
    "modelKey": "xinli:plant:玫瑰",
    "modelUrl": "/static/models/心理沙盘模型/植物/兰草+玫瑰/玫瑰/hua01.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/兰草+玫瑰/玫瑰/玫瑰.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/兰草+玫瑰/oo1.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "蘑菇",
    "emoji": "🌿",
    "modelKey": "xinli:plant:蘑菇",
    "modelUrl": "/static/models/心理沙盘模型/植物/蘑菇/mogu_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/植物/蘑菇/蘑菇.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/蘑菇/Tex_mogu.png",
    "targetHeight": 0.225
  },
  {
    "tab": "plant",
    "label": "柠檬",
    "emoji": "🌿",
    "modelKey": "xinli:plant:柠檬",
    "modelUrl": "/static/models/心理沙盘模型/植物/柠檬/ningmeng.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/柠檬/柠檬.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/柠檬/map_ningmeng.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "蒲公英",
    "emoji": "🌿",
    "modelKey": "xinli:plant:蒲公英",
    "modelUrl": "/static/models/心理沙盘模型/植物/蒲公英/PT_Dandelion_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/植物/蒲公英/蒲公英.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/蒲公英/PT_Dandelion_01.png",
    "cutoutTexture": true,
    "meshKeep": [
      "PT_Dandelion_01_LOD0"
    ],
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "牵牛花",
    "emoji": "🌿",
    "modelKey": "xinli:plant:牵牛花",
    "modelUrl": "/static/models/心理沙盘模型/植物/牵牛花/PT_Thornapple_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/植物/牵牛花/牵牛花（暂定）.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/牵牛花/PT_Thornapple_01.png",
    "cutoutTexture": true,
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "榕树",
    "emoji": "🌿",
    "modelKey": "xinli:plant:榕树",
    "modelUrl": "/static/models/心理沙盘模型/植物/榕树/PT_Generic_Tree_04_green.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/植物/榕树/榕树.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/榕树/PT_Generic_Leaves_01.png",
    "targetHeight": 0.9
  },
  {
    "tab": "plant",
    "label": "珊瑚1",
    "emoji": "🌿",
    "modelKey": "xinli:plant:珊瑚1",
    "modelUrl": "/static/models/心理沙盘模型/植物/珊瑚/珊瑚1/shanhu_01.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/珊瑚/珊瑚1/珊瑚1.PNG",
    "textureUrl": "/static/models/心理沙盘模型/植物/珊瑚/海底.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "珊瑚2",
    "emoji": "🌿",
    "modelKey": "xinli:plant:珊瑚2",
    "modelUrl": "/static/models/心理沙盘模型/植物/珊瑚/珊瑚2/shanhu_02.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/珊瑚/珊瑚2/珊瑚2.PNG",
    "textureUrl": "/static/models/心理沙盘模型/植物/珊瑚/海底.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "珊瑚3",
    "emoji": "🌿",
    "modelKey": "xinli:plant:珊瑚3",
    "modelUrl": "/static/models/心理沙盘模型/植物/珊瑚/珊瑚3/shanhu_03.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/珊瑚/珊瑚3/珊瑚3.PNG",
    "textureUrl": "/static/models/心理沙盘模型/植物/珊瑚/海底.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "珊瑚4",
    "emoji": "🌿",
    "modelKey": "xinli:plant:珊瑚4",
    "modelUrl": "/static/models/心理沙盘模型/植物/珊瑚/珊瑚4/shanhu_04.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/珊瑚/珊瑚4/珊瑚4.PNG",
    "textureUrl": "/static/models/心理沙盘模型/植物/珊瑚/海底.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "圣诞树",
    "emoji": "🌿",
    "modelKey": "xinli:plant:圣诞树",
    "modelUrl": "/static/models/心理沙盘模型/植物/圣诞树/shengdanshu.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/圣诞树/圣诞树.PNG",
    "meshTextures": {
      "shengdan_xing": "/static/models/心理沙盘模型/植物/圣诞树/shengdan_xing.png",
      "shengdan_shuzhi01": "/static/models/心理沙盘模型/植物/圣诞树/shengdan_shuzhi01.png",
      "shengdan_shuzhi02": "/static/models/心理沙盘模型/植物/圣诞树/shengdan_shuzhi02.png",
      "shengdan_caideng": "/static/models/心理沙盘模型/植物/圣诞树/shengdan_caideng.png"
    },
    "meshTextureCutout": [
      "shengdan_xing",
      "shengdan_shuzhi01",
      "shengdan_shuzhi02",
      "shengdan_caideng"
    ],
    "modelRotation": [-1.5707963267948966, 0, 0],
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "松树",
    "emoji": "🌿",
    "modelKey": "xinli:plant:松树",
    "modelUrl": "/static/models/心理沙盘模型/植物/松树/Tree_4B.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/植物/松树/松树.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/松树/Tree_1A_D.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "太阳花",
    "emoji": "🌿",
    "modelKey": "xinli:plant:太阳花",
    "modelUrl": "/static/models/心理沙盘模型/植物/各种花/太阳花/太阳花.obj",
    "thumbUrl": "/static/models/心理沙盘模型/植物/各种花/太阳花/太阳花.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/各种花/CT_Pallete.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "桃花树",
    "emoji": "🌿",
    "modelKey": "xinli:plant:桃花树",
    "modelUrl": "/static/models/心理沙盘模型/植物/桃花树/taohuashu.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/桃花树/桃花树预览图.PNG",
    "textureUrl": "/static/models/心理沙盘模型/植物/桃花树/桃花树.PNG",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.9
  },
  {
    "tab": "plant",
    "label": "桃子",
    "emoji": "🌿",
    "modelKey": "xinli:plant:桃子",
    "modelUrl": "/static/models/心理沙盘模型/植物/桃子/taozi.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/桃子/桃子.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/桃子/map_taozi.png",
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "西瓜",
    "emoji": "🌿",
    "modelKey": "xinli:plant:西瓜",
    "modelUrl": "/static/models/心理沙盘模型/植物/西瓜/xigua_01.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/西瓜/西瓜_01.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/西瓜/map_xigua.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "香蕉",
    "emoji": "🌿",
    "modelKey": "xinli:plant:香蕉",
    "modelUrl": "/static/models/心理沙盘模型/植物/香蕉/xiangjiao.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/香蕉/香蕉.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/香蕉/PolygonTown_Texture_04_A.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "向日葵",
    "emoji": "🌿",
    "modelKey": "xinli:plant:向日葵",
    "modelUrl": "/static/models/心理沙盘模型/植物/向日葵/sunflower.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/向日葵/向日葵.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/向日葵/tex_sunflower.png",
    "cutoutTexture": true,
    "modelRotation": [0, 0, 0],
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "橡树",
    "emoji": "🌿",
    "modelKey": "xinli:plant:橡树",
    "modelUrl": "/static/models/心理沙盘模型/植物/橡树/Tree_2D.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/植物/橡树/大树03.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/橡树/Tree_1A_D.png",
    "targetHeight": 0.9
  },
  {
    "tab": "plant",
    "label": "樱花树",
    "emoji": "🌿",
    "modelKey": "xinli:plant:樱花树",
    "modelUrl": "/static/models/心理沙盘模型/植物/樱花树/yinghuashu01.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/樱花树/樱花树01.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/樱花树/map_gufeng 1.png",
    "targetHeight": 0.9
  },
  {
    "tab": "plant",
    "label": "郁金香(红）",
    "emoji": "🌿",
    "modelKey": "xinli:plant:郁金香红",
    "modelUrl": "/static/models/心理沙盘模型/植物/各种花/郁金香(红）/郁金香（红）.obj",
    "thumbUrl": "/static/models/心理沙盘模型/植物/各种花/郁金香(红）/郁金香（红）.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/各种花/CT_Pallete.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "郁金香(黄)",
    "emoji": "🌿",
    "modelKey": "xinli:plant:郁金香黄",
    "modelUrl": "/static/models/心理沙盘模型/植物/各种花/郁金香(黄)/郁金香（黄）.obj",
    "thumbUrl": "/static/models/心理沙盘模型/植物/各种花/郁金香(黄)/郁金香（黄）.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/各种花/CT_Pallete.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "紫罗兰",
    "emoji": "🌿",
    "modelKey": "xinli:plant:紫罗兰",
    "modelUrl": "/static/models/心理沙盘模型/植物/各种花/紫罗兰/紫罗兰.obj",
    "thumbUrl": "/static/models/心理沙盘模型/植物/各种花/紫罗兰/紫罗兰.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/各种花/CT_Pallete.png",
    "targetHeight": 0.45
  },
  {
    "tab": "plant",
    "label": "竹子1",
    "emoji": "🌿",
    "modelKey": "xinli:plant:竹子1",
    "modelUrl": "/static/models/心理沙盘模型/植物/竹子/竹子1/zhuzi01.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/竹子/竹子1/竹子01.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/竹子/map_gufeng 1.png",
    "targetHeight": 0.9
  },
  {
    "tab": "plant",
    "label": "竹子2",
    "emoji": "🌿",
    "modelKey": "xinli:plant:竹子2",
    "modelUrl": "/static/models/心理沙盘模型/植物/竹子/竹子2/zhuzi03.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/竹子/竹子2/竹子03.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/竹子/map_gufeng 1.png",
    "targetHeight": 0.9
  },
  {
    "tab": "plant",
    "label": "竹子3",
    "emoji": "🌿",
    "modelKey": "xinli:plant:竹子3",
    "modelUrl": "/static/models/心理沙盘模型/植物/竹子/竹子3/zhulin01.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/植物/竹子/竹子3/竹林01.png",
    "textureUrl": "/static/models/心理沙盘模型/植物/竹子/map_gufeng 1.png",
    "targetHeight": 0.9
  },
  {
    "tab": "transport",
    "label": "出租车",
    "emoji": "🚗",
    "modelKey": "xinli:transport:出租车",
    "modelUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/出租车/SM_Veh_Car_Taxi_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/出租车/出租车.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/PolygonCity_Texture_01_A.png",
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "帆船",
    "emoji": "🚗",
    "modelKey": "xinli:transport:帆船",
    "modelUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/fanchuan.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/fanchuan.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/SimplePort.png",
    "modelRotation": [-1.5, 3.141592653589793, 0],
    "defaultPropPitch": 1.5707963267948966,
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "警船",
    "emoji": "🚗",
    "modelKey": "xinli:transport:警船",
    "modelUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/jingchuan.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/jingchuan.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/SimplePort.png",
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "救生艇",
    "emoji": "🚗",
    "modelKey": "xinli:transport:救生艇",
    "modelUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/jiushengting.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/jiushengting.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/SimplePort.png",
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "游艇",
    "emoji": "🚗",
    "modelKey": "xinli:transport:游艇",
    "modelUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/youting.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/youting.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/船（共用贴图）/SimplePort.png",
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "大巴车",
    "emoji": "🚗",
    "modelKey": "xinli:transport:大巴车",
    "modelUrl": "/static/models/心理沙盘模型/交通/大巴车/Vehicle_Bus_color01.obj",
    "thumbUrl": "/static/models/心理沙盘模型/交通/大巴车/公共汽车.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/大巴车/Vehicle_Bus_1.png",
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "飞机",
    "emoji": "🚗",
    "modelKey": "xinli:transport:飞机",
    "modelUrl": "/static/models/心理沙盘模型/交通/飞机/Plane01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/交通/飞机/飞机.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/飞机/SimpleAirport.png",
    "modelRotation": [-1.5707963267948966, -1.5707963267948966, -1.5707963267948966],
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "火箭",
    "emoji": "🚗",
    "modelKey": "xinli:transport:火箭",
    "modelUrl": "/static/models/心理沙盘模型/交通/火箭/huojian.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/交通/火箭/火箭.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/火箭/tex_hangkong.png",
    "targetHeight": 1.25
  },
  {
    "tab": "transport",
    "label": "货车",
    "emoji": "🚗",
    "modelKey": "xinli:transport:货车",
    "modelUrl": "/static/models/心理沙盘模型/交通/货车/Vehicle_Container_color01.obj",
    "thumbUrl": "/static/models/心理沙盘模型/交通/货车/集装箱01.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/货车/Vehicle_Container_1.png",
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "警车",
    "emoji": "🚗",
    "modelKey": "xinli:transport:警车",
    "modelUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/警车/SM_Veh_Car_Police_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/警车/警车.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/PolygonCity_Texture_01_A.png",
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "救护车",
    "emoji": "🚗",
    "modelKey": "xinli:transport:救护车",
    "modelUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/救护车/SM_Veh_Car_Ambo_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/救护车/救护车.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/PolygonCity_Texture_01_A.png",
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "小汽车",
    "emoji": "🚗",
    "modelKey": "xinli:transport:小汽车",
    "modelUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/小汽车/SM_Veh_Car_Muscle_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/小汽车/小汽车.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/PolygonCity_Texture_01_A.png",
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "渔船",
    "emoji": "🚗",
    "modelKey": "xinli:transport:渔船",
    "modelUrl": "/static/models/心理沙盘模型/交通/渔船/boat.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/交通/渔船/chuan.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/渔船/mm.png",
    "modelRotation": [-1.5707963267948966, -1.5707963267948966, -1.5707963267948966,],
    "targetHeight": 1.0
  },
  {
    "tab": "transport",
    "label": "自行车",
    "emoji": "🚗",
    "modelKey": "xinli:transport:自行车",
    "modelUrl": "/static/models/心理沙盘模型/交通/自行车/zixingche.FBX",
    "thumbUrl": "/static/models/心理沙盘模型/交通/自行车/自行车.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/自行车/map_zixingche_c.png",
    "modelRotation": [-1.5707963267948966, -1.5707963267948966, -1.5707963267948966,],
    "targetHeight": 0.5
  },
  {
    "tab": "transport",
    "label": "SUV",
    "emoji": "🚗",
    "modelKey": "xinli:transport:SUV",
    "modelUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/SUV/SM_Veh_Car_Medium_01.fbx",
    "thumbUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/SUV/SUV.png",
    "textureUrl": "/static/models/心理沙盘模型/交通/各种小轿车合集/PolygonCity_Texture_01_A.png",
    "targetHeight": 1.0
  }
]



// WEBPACK FOOTER //
// ./src/config/xinliSandManifest.js